import React, { ButtonHTMLAttributes, FC } from "react";
import { generateClient } from "aws-amplify/api";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useLightboxState } from "yet-another-react-lightbox";
import { updateArtCustom } from "../../src/graphql/custom_mutations";
// GraphQL imports
import { UpdateArtInput, UpdateArtMutation } from "../../src/API";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  filenames: string[];
  childToParent: (childdata: number) => void;
}

const DeleteButton: FC<ButtonProps> = ({
  filenames,
  childToParent,
  children,
  ...rest
}) => {
  const client = generateClient();
  const { currentIndex } = useLightboxState();

  async function handleRemove(key: string) {
    // Display a confirmation dialog
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this item forever?",
    );

    if (confirmDelete) {
      const input: UpdateArtInput = {
        id: key,
        deleted: true,
      };
      // Save to database by calling API
      (await client.graphql({
        query: updateArtCustom,
        variables: {
          input,
        },
      })) as { data: UpdateArtMutation; errors: unknown[] };
      childToParent(-1);
    } else {
      // User canceled the deletion
    }
  }

  return (
    <button
      type="button"
      id="delete"
      onClick={() => handleRemove(filenames[currentIndex])}
      {...rest}
      className="delete-button"
    >
      {children}
      <DeleteForeverIcon className="DeleteButton" />
      <span className="tooltip">Delete from Gallery</span>
      <style>{`
        .DeleteButton {
          color: black;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }

        .DeleteButton:hover {
          color: #D3D3D3;
        }

        .delete-button {
          position: relative; /* Add relative positioning */
          color: black;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          padding-top: 10px;
          padding-bottom: 10px;
          padding-right: 15px;
          padding-left: 15px;
        }
        
        @media (min-width: 600px) {
          .DeleteButton {
            height: 36px;
            width: 36px;
            color: black;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          }
          .delete-button {
            padding-top: 10px;
            padding-bottom: 10px;
            padding-right: 15px;
            padding-left: 15px;
          }
        }

        .tooltip {
          position: absolute;
          bottom: 50px;
          left: 50%;
          transform: translateX(-50%);
          background-color: rgba(0, 0, 0, 0.7);
          color: #D3D3D3;
          padding: 5px;
          border-radius: 4px;
          font-size: 14px;
          white-space: nowrap; /* Prevent tooltip text from wrapping */
          width: auto; /* Adjust the width as needed */
          min-width: 100px; /* Set a minimum width to avoid being too narrow */
          text-align: center; /* Center the text horizontally */
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.3s, visibility 0.3s;
        }

        .delete-button:hover .tooltip {
          opacity: 1;
          visibility: visible;
        }

      `}</style>
    </button>
  );
};

export default DeleteButton;
